import React from 'react';
import founderBg from '../../../assets/site/bg-insights.jpg';
import founderPhoto from '../../../assets/site/sammy-dutta-cutout.webp';
import Section from '../../site/components/Section';
import cx from '../../site/utils/cx';
import ui from '../../site/styles/primitives.module.css';
import { founder } from '../aboutContent';
import styles from './Founder.module.css';

const Founder = () => (
  <Section id="founder" background={founderBg} backgroundPosition="center 40%">
    <div className={cx(ui.wrap, styles.grid)}>
      <div className={styles.photo} data-reveal="">
        <div className={styles.frame} aria-hidden="true" />
        <div className={styles.frameOutline} aria-hidden="true" />
        <img
          src={founderPhoto}
          alt={`${founder.name}, ${founder.role} of DS360 Investment`}
          width="900"
          height="1268"
          loading="lazy"
        />
        <div className={styles.nameplate}>
          <b>{founder.name}</b>
          <span>{founder.role}</span>
        </div>
      </div>

      <div className={styles.text} data-reveal="">
        <span className={ui.eyebrow}>Our founder</span>
        <h2 className={styles.title}>
          Meet <span className={ui.grad}>{founder.name}</span>
        </h2>
        {founder.bio.map((paragraph) => (
          <p key={paragraph.slice(0, 32)}>{paragraph}</p>
        ))}

        <dl className={styles.facts}>
          {founder.facts.map((fact) => (
            <div key={fact.label}>
              <dt>{fact.label}</dt>
              <dd>{fact.value}</dd>
            </div>
          ))}
        </dl>

        <figure className={styles.quote}>
          <blockquote>“{founder.quote}”</blockquote>
          <figcaption>
            — {founder.name}, {founder.role}
          </figcaption>
        </figure>
      </div>
    </div>
  </Section>
);

export default Founder;
